import { render, staticRenderFns } from "./StaffCountDashboard.vue?vue&type=template&id=bf7a6d20&scoped=true&"
import script from "./StaffCountDashboard.vue?vue&type=script&lang=js&"
export * from "./StaffCountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7a6d20",
  null
  
)

export default component.exports